import { Location } from 'history'

import { BaseRoute } from 'src/routes/BaseRoute'
import Action from 'src/redux/action'
import { openRoute } from 'src/redux/actions/routes'
import { DashboardRoute } from 'src/dashboard/routes/DashboardRoute'
import { AccountRoute } from 'src/dashboard/routes/AccountRoute'

const getArgs = (
  location: Location<object | null>,
): { [key: string]: string | undefined } =>
  location.search
    .split('?')
    .slice(-1)[0]
    .split('&')
    .map(keyValueString => keyValueString.split('='))
    .reduce((args, [key, value]) => ({ ...args, [key]: value }), {})

const redirect = (pathname: string) =>
  pathname.replace('campaign-store', 'campaigns/store')

const actionForLocation = (location: Location<object | null>): Action => {
  const route = BaseRoute.fromPath(redirect(location.pathname), location)
  const args = getArgs(location)
  if (route) {
    return openRoute(route, args)
  } else {
    return openRoute(BaseRoute(DashboardRoute(AccountRoute())), args)
  }
}

export default actionForLocation
